<template>
  <div  class="top-warp" :style="{ color: $$FormData.text_color, backgroundColor: $$FormData.background_color }">
    <div v-if="$$FormData.show_content === 'SM'" class="sm">
      <div class="addr-view">
        <div class="addr-icon"><i class="el-icon-location-outline" size="32"></i></div>
        <span class="addr-text">请完善地址</span>
        <div class="down-icon"><i class="el-icon-arrow-down" size="24"></i></div>
      </div>
      <div class="my-view">
        <img class="my-icon" src="@/assets/sam_icon_my.png" />
      </div>
    </div>
    <div v-if="$$FormData.show_content === 'YH'" class="sm">
      <div class="addr-view">
        <span class="addr-text">{{ $$FormData.content_text }}</span>
      </div>
      <div class="my-view">
        <img class="my-icon" src="@/assets/sam_icon_my.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderPreview"
}
</script>

<style lang="scss" scoped>
  .top-warp {
    .sm {
      font-size: 14px;
      display: flex;
      align-items: center;
      padding: 10px 15px 5px 10px;
      .addr-view {
        display: flex;
        align-items: center;
        flex: 1;

        .addr-icon {
          margin-top: 3px;
        }

        .addr-text {
          margin: 0 5px;
        }
      }
      .my-view {
        .my-icon {
          width: 20px;
        }
      }
    }
  }
</style>